var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination',{staticClass:"mx-1",attrs:{"value":_vm.currentPage,"total-rows":_vm.rows,"per-page":_vm.perPage,"page-class":[''],"prev-text":"前","next-text":"次","limit":"10"}})
}
var staticRenderFns = []

export { render, staticRenderFns }